import React from 'react'
import { Redirect } from 'react-router-dom'

function AutopayRedirect() {
    return (<Redirect to="/products"/>)
}

export default AutopayRedirect